import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { withRouter, NavLink, useLocation } from "react-router-dom";
import "@material/react-text-field/dist/text-field.css";
import { Image, Box, useDisclosure, Button } from "@chakra-ui/core";
import queryString from "query-string";
import { useStore, useActions } from "configureStore";
import { theme } from "theme";
import BannerShellPromo from "modules/promocaoJunteTroque/Navbar/BannerShellPromo";
import { TopBar } from "modules/common/UI";
import MenuMobile from "modules/common/Navbar/Menu";
import UpdatePersonalDataModal from "modules/common/UpdataPersonalDataModal";

import menu from "assets/icons/new-hamburguer.svg";
import closeIcon from "assets/icons/close.svg";
import logoPromo from "assets/icons/logo-promo-shell.svg";

import iconShell from "assets/icons/logo-shell.svg"
import { useAnchor } from "hooks/useAnchor";

const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 23.5px;

  @media (min-width: 769px) {
    display: none;
  }
`
const Navbar = (props) => {
  const query = queryString.parse(props.location.search);
  const queryshellBox = query.shellbox;
  const { pathname } = useLocation();

  const setIsOpen = useActions((action) => action.home.setIsOpen);
  const isAuthenticated = useStore((state) => state.auth.isAuthenticated);
  const { scrollToAnchor } = useAnchor({offset: 0})

  // Efeito de delay do botão "Entrar"
  const [opacityEffect, setOpacityEffect] = useState(0);
  const [isEffectActive, SetIsEffectActive] = useState(false);

  useEffect(() => {
    if (opacityEffect <= 1 && isEffectActive) {
      setTimeout(() => {
        setOpacityEffect(opacityEffect + 0.1);
      }, 50);
    }
  }, [isEffectActive, opacityEffect]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const close = () => setIsOpen(false);

  useEffect(() => {
    close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const btnRef = useRef();

  const location = props.history.location.pathname;
  const [openMenu, setOpenMenu] = useState(false);

  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <Content
        display={queryshellBox?.includes("hiddenComponent") ? "none" : "flex"}
      >
        <ContentBox>
          <Box display="flex" justifyContent="space-between" alignItems="center">
              <Logo
                tabIndex={0}
                aria-label="promoshell"
                onClick={() => {
                  scrollToTop();
                  if (
                    localStorage.getItem("query_shell") !== "null" &&
                    localStorage.getItem("query_shell")?.length > 1
                  ) {
                    props.history.push(
                      `/?shellbox=${localStorage.getItem("query_shell")}`
                    );
                  } else {
                    props.history.push(`/`);
                  }
                }}
              >

              <img src={logoPromo} alt="promoshell" />
            </Logo>

            <IconGroup>
              <MenuIcon
                height={"45px"}
                width={"44px"}
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                onClick={() =>
                  !openMenu ? setOpenMenu(true) : setOpenMenu(false)
                }
              >
                {!openMenu ? (
                  <Image
                    src={menu}
                    alt="hamburger-icon"
                    width="32px"
                    height="30px"
                  />
                ) : (
                  <Image
                    src={closeIcon}
                    alt="hamburger-icon"
                    width="32px"
                    height="30px"
                  />
                )}
              </MenuIcon>

              <Image src={iconShell} alt="" />
            </IconGroup>
            
          </Box>
          {isAuthenticated ? (
            <WrapLinks mLeft={props.auth ? 0 : "0"}>
              <CustomNavLink
                aria-label="promocões da cidade"
                to={"/"}
                onClick={() => {
                  scrollToTop();
                }}
              >
                <BarLink
                  height={2}
                  width={50}
                  className={`${location === "/" && "activeLink"} barLink`}
                />
                <span>
                  Campanhas
                  <br /> de Cidade
                </span>
              </CustomNavLink>
              <CustomNavLink
                aria-label="Campanhas de óleos lubrificantes"
                onClick={() => {
                  scrollToTop();
                }}
                to={"/campanhas-de-lubrificantes"}
              >
                <BarLink
                  height={2}
                  width={50}
                  className={`${
                    location === "/campanhas-de-lubrificantes" && "activeLink"
                  } barLink`}
                />
                <span>
                  Campanhas de
                  <br /> Óleos Lubrificantes
                </span>
              </CustomNavLink>
              <CustomNavLink
                aria-label="promocões de rodovia"
                onClick={() => {
                  scrollToTop();
                }}
                to={"/promocoes-de-rodovia"}
              >
                <BarLink
                  height={2}
                  width={50}
                  className={`${
                    location === "/promocoes-de-rodovia" && "activeLink"
                  } barLink`}
                />
                <span>
                  Campanhas
                  <br /> de Rodovia 1
                </span>
              </CustomNavLink>
              <CustomNavLink
                aria-label="benefícios app shell box"
                onClick={() => {
                  scrollToTop();
                }}
                to={"/beneficios-app-shell-box"}
              >
                <BarLink
                  height={2}
                  width={50}
                  className={`${
                    location === "/beneficios-app-shell-box" && "activeLink"
                  } barLink`}
                />
                <span>
                  benefícios <br />
                  shell box
                </span>
              </CustomNavLink>
            </WrapLinks>
          ) : (
            <WrapLinks mLeft={props.auth ? 0 : "0"}>
              <CustomAnchor href="#promocoes" onClick={
                (e) => {
                  e.preventDefault();
                  window.history.pushState(null, "", "#promocoes");
                  scrollToAnchor("promocoes")
                }
              }>
                <span>
                  Promoções
                </span>
              </CustomAnchor>

              <CustomAnchor href="#para-voce" onClick={
                (e) => {
                  e.preventDefault();
                  window.history.pushState(null, "", "#para-voce");
                  scrollToAnchor("para-voce")
                }
              }>
                <span>
                  Para você
                </span>
              </CustomAnchor>

              <CustomAnchor href="#para-seu-veiculo" onClick={
                (e) => {
                  e.preventDefault();
                  window.history.pushState(null, "", "#para-seu-veiculo");
                  scrollToAnchor("para-seu-veiculo")
                }
              }>
                <span>
                  Para o seu veículo
                </span>
              </CustomAnchor>
                                          
              <CustomLink
                aria-label="Ajuda"
                href={"https://www.shell.com.br/sobre-a-shell/fale-conosco.html"}
                target="_blank"
              >
                <span>Ajuda</span>
              </CustomLink>
              
              <Image src={iconShell} alt="" />
            </WrapLinks>
          )}
        </ContentBox>
        <UpdatePersonalDataModal isOpen={isOpen} onClose={onClose} />
      </Content>

      {window.location.pathname === "/" ? (
        <Box>{/* <SliderHome />
          <BannerShell /> */}</Box>
      ) : (
        window.location.pathname === "/promocao-junte-e-troque" && (
          <BannerShellPromo />
        )
      )}
      {window.location.pathname === `/promocao-junte-e-troque/` && (
        <BannerShellPromo />
      )}
      {window.location.pathname === "/cadastro" && (
        <TopBar title={isAuthenticated ? "Meu Cadastro" : "Cadastre-se"} />
      )}
      {window.location.pathname === "/minhas-promocoes" && (
        <TopBar title="CAMPANHAS" />
      )}
      {window.location.pathname === "/duvidas" && <TopBar title="Dúvidas" />}
      {window.location.pathname === "/termos-de-uso" && (
        <TopBar title="Termos de uso" />
      )}
      {window.location.pathname === "/politica-de-privacidade" && (
        <TopBar title="Política de privacidade" />
      )}
      {window.location.pathname === "/regulamento" && (
        <TopBar title="Regulamento" />
      )}
      {window.location.pathname === "/esqueceu-a-senha" && (
        <TopBar title="Recuperar senha" />
      )}
      {window.location.pathname === "/sobre-o-promoshell" && (
        <TopBar title="Sobre o PromoShell" />
      )}
      <MenuMobile ref={btnRef} onClose={() => setOpenMenu(false)} isOpen={openMenu} />
    </>
  );
};

export default withRouter(Navbar);

const Content = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  background: ${(props) => props.theme.color.white};
  z-index: 99;
  position: fixed;
  top: 0;
  width: 100%;
  height: 87px;
  /* @media (max-width: ${(props) => props.theme.queries.medium}) {
    height: 43px;
    padding: 0 0em;
  } */
  @media (max-width: ${(props) => props.theme.queries.medium}) {
    padding: 28px 22px;
  }
`;

const ContentBox = styled(Box)`
  max-width: 1450px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1440px) {
    max-width: 97.5%;
  }
  /* @media (max-width: ${(props) => props.theme.queries.medium}) {
    max-width: 94%;
  } */
  @media (max-width: ${(props) => props.theme.queries.medium}) {
    max-width: 100%;
  }
`;

const WrapLinks = styled(Box)`
  display: flex;
  align-items: center;
  margin-left: ${(props) => props.mLeft};
  @media (max-width: ${(props) => props.theme.queries.lg}) {
    margin-left: 0%;
  }
  @media (max-width: ${(props) => props.theme.queries.medium}) {
    display: none;
  }
  .activeLink {
    background: linear-gradient(to right, #e98624 50%, #e98624 50%);
  }
`;

const BarLink = styled(Box)`
  height: 3px !important;
  margin-bottom: 0.5rem;
  transition: 0.3s;

  background: linear-gradient(to right, #e98624 50%, #eaeaea 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  transition: all 0.2s ease-out;

  @media (max-width: ${(props) => props.theme.queries.medium}) {
    display: none !important;
  }
`;

const CustomNavLink = styled(NavLink)`
  color: ${(props) => props.theme.color.text};
  margin-right: 40px;
  padding: 12px 18px;
  text-decoration: none;
  font-family: "Shell Heavy";
  font-size: 18px;
  line-height: 160%;
  transition: 0.2s;
  border: solid 1px transparent;
  border-radius: 8px;

  :hover,
  :focus {
    background-color: #F5F5F5;
    border-color: #DCDCDC;
  }

  span {
    margin: 0.4rem 0 0 0;
    font-weight: 600;
    text-decoration: none;
    color: ${(props) => props.theme.color.gray};
  }

  @media (max-width: ${(props) => props.theme.queries.lg}) {
    span {
      margin: 0;
      font-size: 10px;
    }
  }

  @media (max-width: ${(props) => props.theme.queries.medium}) {
    margin-right: 33px;
  }
`;

const CustomAnchor = styled.a`
  color: ${(props) => props.theme.color.text};
  margin-right: 40px;
  padding: 12px 18px;
  text-decoration: none;
  font-family: "Shell Heavy";
  font-size: 18px;
  line-height: 160%;
  transition: 0.2s;
  border: solid 1px transparent;
  border-radius: 8px;

  :hover,
  :focus {
    background-color: #F5F5F5;
    border-color: #DCDCDC;
  }

  span {
    margin: 0.4rem 0 0 0;
    font-weight: 600;
    text-decoration: none;
    color: ${(props) => props.theme.color.gray};
  }

  @media (max-width: ${(props) => props.theme.queries.lg}) {
    span {
      margin: 0;
      font-size: 10px;
    }
  }

  @media (max-width: ${(props) => props.theme.queries.medium}) {
    margin-right: 33px;
  }
`;

const CustomLink = styled.a`
  color: ${(props) => props.theme.color.text};
  margin-right: 40px;
  padding: 12px 18px;
  text-decoration: none;
  font-family: "Shell Heavy";
  font-size: 18px;
  line-height: 160%;
  transition: 0.2s;
  border: solid 1px transparent;
  border-radius: 8px;

  :hover,
  :focus {
    background-color: #F5F5F5;
    border-color: #DCDCDC;
  }

  span {
    margin: 0.4rem 0 0 0;
    font-weight: 600;
    text-decoration: none;
    color: ${(props) => props.theme.color.gray};
  }

  @media (max-width: ${(props) => props.theme.queries.lg}) {
    span {
      margin: 0;
      font-size: 10px;
    }
  }

  @media (max-width: ${(props) => props.theme.queries.medium}) {
    margin-right: 33px;
  }
`;

const Logo = styled.div`
  img {
    max-width: 250px;
    max-height: 80px;
  }

  @media (max-width: ${(props) => props.theme.queries.medium}) {
    img {
      max-width: 140px;
      max-height: 40px;
    }
  }
`;

const MenuIcon = styled(Box)`
  display: none;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.queries.medium}) {
    display: flex;
  }
`;

//auth true

const BoxWelcome = styled(Box)`
  display: flex;
  align-items: center;

  .boxUser {
    padding: 0 !important;
    height: auto !important;
    border: none;
    background-color: white !important;
    font-weight: 500 !important;
    font-family: ${theme.FuturaFont};

    :hover,
    :focus {
      div {
        color: ${(props) => props.theme.color.orange};
      }
      .iconUser {
        border: 3px solid ${(props) => props.theme.color.orange} !important;
      }
    }
  }
`;

const WelcomeUser = styled(Box)`
  margin-right: 5px;
  font-family: ${theme.FuturaFont};
  cursor: pointer;
  color: #525f7f;
  font-weight: 500 !important;

  @media (max-width: ${(props) => props.theme.queries.small}) {
    padding: 0;
    margin: 0 0.2rem 0 0;
    font-size: 12px;
    text-align: right;
    line-height: 10px;
    color: ${(props) => props.theme.color.gray};
  }
`;

const ImageUser = styled.img`
  cursor: pointer;
  margin-top: 2px;
  border-radius: 10rem;
  border: 3px solid transparent;
  transition: 0.3s;

  @media (max-width: ${(props) => props.theme.queries.small}) {
    margin-top: 0;
  }
`;